import Avatar from 'react-avatar';
import ReadMore from '../../../../components/Common/ReadMore';
import { ImageFileUtil } from '../../../../utils';

function ManagerComment({ selectedKPI, performanceHeader }) {
  const header = performanceHeader?.[0];

  const getImage = () => {
    if (header?.MgrImagefile) {
      return ImageFileUtil.getEmployeeFilePath(header?.MgrImagefile);
    }
    return null;
  };

  return (
    <div className="comments pt-2">
      <div className="comment">
        <Avatar
          name={header?.MgrName || 'Unknown'}
          size="32px"
          color="#CFCBDC"
          fgColor="#475467"
          style={{
            fontSize: '14px',
            fontWeight: '600',
          }}
          src={getImage()}
          round
        />
        <div className="commentContent">
          <div className="title">{header?.MgrName?.trim()} (Manager)</div>
          <div className="per-description fs-6">
            <ReadMore htmlString={selectedKPI?.Rating_Mgr_Comments} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManagerComment;
